const path = require('path')

const router = require('../../router')


module.exports = (graphql, actions, route) => {
  const { createPage } = actions
  const template = path.resolve('src/templates/AllProjects/index.js')

  return graphql(`
    query {
      allContentfulProject {
        edges {
          node {
            node_locale
            id
            domain {
              id
              domain
            }
            title
            isOnDisplay
            slug
          }
        }
      }
    }
  `).then((result) => {
    if (result.errors) {
      throw result.errors
    }
    result.data.allContentfulProject.edges.forEach(({ node }) => {
      createPage({
        path: router(route.path, { locale: node.node_locale }),
        component: template,
        context: {
          langKey: node.node_locale,
        },
      })
    })
  })
}
